import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe, StripDisplayPipe } from './_helpers';
import { DialogUploadComponent } from './sidepanel/dialog-upload/dialog-upload.component';
import { DialogUpdateComponent } from './sidepanel/dialog-update/dialog-update.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { AuditDocumentComponent } from './sidepanel/audit-document/audit-document.component';
import { MatTableModule } from '@angular/material/table';
import { CommentsSectionComponent } from './sidepanel/comments-section/comments-section.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PopUpComponent } from './common/pop-up/pop-up.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule, 
    FormsModule, 
    // NgxFilesizeModule, 
    MatTableModule, 
    MatTreeModule, 
    MatButtonModule, 
    MatMenuModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatInputModule
  ],
  declarations: [
    StripDisplayPipe, 
    SafePipe, 
    DialogUploadComponent, 
    DialogUpdateComponent, 
    AuditDocumentComponent, 
    CommentsSectionComponent,
    PopUpComponent
  ],
  exports: [
    StripDisplayPipe,
    SafePipe,
    DialogUploadComponent,
    DialogUpdateComponent,
    MatTableModule,
    AuditDocumentComponent,
    CommentsSectionComponent,
    MatTreeModule,
    MatMenuModule,
    MatButtonModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    PopUpComponent
    // NgxFilesizeModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedModuleModule { }
